import type { TFunction } from 'next-i18next';
import type { ParkingCount } from 'domain/listing/value-objects';
import { LOCALE_SEARCH_PATHS } from 'types/locales';

const PLACEHOLDER = '--';

export function formatParkingCount(parking: ParkingCount, t: TFunction): string {
  if (!parking.hasValue) {
    return PLACEHOLDER;
  }

  if (parking.value === 0) {
    return '0';
  }

  return t(LOCALE_SEARCH_PATHS.FILTER_CHIP_PARKING_FORMAT, {
    spaces: parking.value,
    defaultValue: `${parking.value} Parking`,
  });
}
